import React from 'react';

const ReservationTable = ({ reservations, statusLabels, statusColors, onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatPrice = (price) => {
    if (!price) return '0.00 €';
    return `${parseFloat(price).toFixed(2)} €`;
  };

  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>Utilisateur</th>
            <th>Atelier</th>
            <th>Date(s)</th>
            <th>Statut</th>
            <th>Prix total</th>
            <th>Créée le</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reservations.map((reservation) => (
            <tr key={reservation.id}>
              <td>#{reservation.id}</td>
              <td>
                {reservation.user ? (
                  <div>
                    <div className="fw-bold">{reservation.user.username || '-'}</div>
                    <small className="text-muted">{reservation.user.email || '-'}</small>
                  </div>
                ) : reservation.user_details ? (
                  <div>
                    <div className="fw-bold">
                      {reservation.user_details.name || '-'}
                      <span className="badge bg-secondary ms-2" style={{ fontSize: '0.7em' }}>Invité</span>
                    </div>
                    <small className="text-muted">{reservation.user_details.email || '-'}</small>
                  </div>
                ) : (
                  <span className="text-muted">Aucun utilisateur</span>
                )}
              </td>
              <td>
                {reservation.workshop ? (
                  <div>
                    <div className="fw-bold">{reservation.workshop.title || '-'}</div>
                    <small className="text-muted">{reservation.workshop.reference || '-'}</small>
                  </div>
                ) : (
                  <span className="text-muted">-</span>
                )}
              </td>
              <td>
                {reservation.workshop_date && reservation.workshop_date.length > 0 ? (
                  <div>
                    {reservation.workshop_date.map((date, idx) => (
                      <div key={idx} className="small">
                        {formatDate(date.date)}
                      </div>
                    ))}
                  </div>
                ) : (
                  <span className="text-muted">Aucune date</span>
                )}
              </td>
              <td>
                <span className={`badge bg-${statusColors[reservation.resa_status] || 'secondary'}`}>
                  {statusLabels[reservation.resa_status] || reservation.resa_status}
                </span>
              </td>
              <td>{formatPrice(reservation.total_price)}</td>
              <td>{formatDate(reservation.createdAt)}</td>
              <td>
                <div className="btn-group btn-group-sm">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => onEdit(reservation)}
                  >
                    Modifier
                  </button>
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => onDelete(reservation.documentId, reservation.workshop_date)}
                  >
                    Supprimer
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReservationTable;
